import { COMMUNITY } from '@shared/constants/routes/admin/community-routes.constants';
import { FINANCE } from '@shared/constants/routes/admin/finance-routes.constants';
import { OPERATIONS } from '@shared/constants/routes/admin/operations-routes.constants';
import { MARKETPLACE } from '@shared/constants/routes/admin/marketplace-routes.constants';
import { INTELLIGENCE } from '@shared/constants/routes/admin/intelligence-routes.constants';
import { CONFIGURATION } from '@shared/constants/routes/admin/configuration-routes.constants';
export const ADMIN_ROUTE_CONSTANTS = {
  path: 'admin',
  profile: {
    path: 'profile',
    data: {
      breadcrumb: 'MENU_ADMIN.PROFILE',
      icon: 'pi pi-user',
      clickable: false,
      openTab: true
    }
  },

  // Dashboard
  dashboard: {
    // Dashboard routes to Condominium Dashboard
    path: 'condominium/dashboard',
    data: {
      breadcrumb: 'MENU_ADMIN.DASHBOARD',
      icon: 'pi pi-chart-line',
      clickable: true
    }
  },

  condominium: {
    path: 'condominium',
    data: {
      breadcrumb: 'MENU_ADMIN.CONDOMINIUM',
      icon: 'pi pi-building',
      clickable: false,
      openTab: true
    },
    dashboard: {
      path: 'condominium/dashboard',
      data: {
        breadcrumb: 'CONDOMINIUM.DASHBOARD.TITLE',
        icon: 'pi pi-chart-line',
        clickable: true
      }
    },
    edit: {
      path: 'condominium/edit',
      data: {
        breadcrumb: 'CONDOMINIUM.EDIT.TITLE',
        icon: 'pi pi-pencil',
        clickable: true
      }
    },
    maintenance: {
      path: 'condominium/maintenance',
      data: {
        breadcrumb: 'CONDOMINIUM.MAINTENANCE.TITLE',
        icon: 'pi pi-dollar',
        clickable: true
      }
    },
    create: {
      path: 'condominium/create',
      data: {
        breadcrumb: 'MENU_ADMIN.CONDOMINIUM_CREATE',
        icon: 'fa-solid fa-building',
        clickable: false,
        openTab: true
      }
    },
  },
  inDevelop: {
    path: 'indevelop',
    data: {
      breadcrumb: 'MENU_ADMIN.INDEVELOP',
      icon: 'pi pi-home',
      clickable: false,  // Ejemplo: página en desarrollo no clickeable
      openTab: true
    }
  },

  community: COMMUNITY,
  finance: FINANCE,
  operations: OPERATIONS,
  marketplace: MARKETPLACE,
  intelligence: INTELLIGENCE,
  configuration: CONFIGURATION,



};
